import messages from "./messages";

const STEPS_CONTENT = {
  // feed_introduction: [
  //   {
  //     message: messages.feedWelcome,
  //     position: "center"
  //   },
  //   {
  //     message: messages.feedFolders,
  //     selector: "#js-tour-folder",
  //     selectorMobile: "#js-afd-nav .afd-mobile-nav-items:nth-child(2)",
  //     position: "top",
  //     positionMobile: "top"
  //   }
  // ],
  folders_sort: [
    {
      message: messages.foldersWelcome,
      selector: ".js-sort-folders",
      selectorMobile: ".js-sort-folders",
      position: "bottom",
      positionMobile: "top"
    },
    {
      message: messages.foldersSearch,
      selector: "",
      selectorMobile: ".js-afd-nav__button-search",
      position: "bottom",
      positionMobile: "bottom"
    },
    {
      message: messages.foldersTogether,
      selector: "#js-folder-title span",
      selectorMobile: ".js-my-folders-link",
      position: "bottom",
      positionMobile: "bottom"
    }
  ]
};

export default STEPS_CONTENT;
